function convertAsciiBalance(id) {
  let trimId = id.trim();
  let len = trimId.length;
  let halfPoint = Math.floor(len * 0.1);
  let splitId = trimId.slice(-halfPoint);
  splitId = splitId.split("");
  let convertToAscii = splitId.map((char) => {
    return char.charCodeAt(0);
  });
  convertToAscii = convertToAscii.join("");
  convertToAscii = parseInt(convertToAscii);
  return convertToAscii;
}

export default function convertDeviceIds(devices) {
  let ids = [];
  for (let j = 0; j < devices.length; j++) {
    ids.push(convertAsciiBalance(devices[j]));
  }
  return parseInt(ids?.reduce((a, b) => a + "" + b,0));
}
